import {isEmpty} from 'lodash-es';
import type {ReactElement} from 'react';
import {useState} from 'react';

import {Button} from '@/components';
import type {BusinessPoolAccount} from '@/types';

import PoolAccountFormModal from './PoolAccountFormModal';

type PoolAccountUpdateButtonProps = {
  initialData?: BusinessPoolAccount;
};

const PoolAccountUpdateButton = ({
  initialData,
}: PoolAccountUpdateButtonProps): ReactElement => {
  const [showFullScreen, setShowFullScreen] = useState(false);
  const updateLabel = isEmpty(initialData)
    ? 'Create Pool Account +'
    : 'Update Pool Account';
  const toggleFullScreen = () => {
    setShowFullScreen(!showFullScreen);
  };

  return showFullScreen ? (
    <PoolAccountFormModal
      isOpen={showFullScreen}
      onClose={toggleFullScreen}
      initialData={initialData}
    />
  ) : (
    <Button
      variant="solid"
      colorScheme="cyan"
      onClick={toggleFullScreen}
      dataCy={
        isEmpty(initialData)
          ? 'merchant-pool-accounts-create'
          : 'merchant-pool-accounts-edit'
      }
    >
      {updateLabel}
    </Button>
  );
};

export default PoolAccountUpdateButton;
